/**
 * Simple ANSI to HTML converter for terminal output
 */

export function ansiToHtml(text: string): string {
  // Basic ANSI color codes mapping
  const colorMap: Record<string, string> = {
    '30': 'color: #000',
    '31': 'color: #d32f2f',
    '32': 'color: #388e3c',
    '33': 'color: #f57c00',
    '34': 'color: #1976d2',
    '35': 'color: #7b1fa2',
    '36': 'color: #0097a7',
    '37': 'color: #bdbdbd',
    '90': 'color: #616161',
    '91': 'color: #ff6659',
    '92': 'color: #66bb6a',
    '93': 'color: #ffa726',
    '94': 'color: #42a5f5',
    '95': 'color: #ab47bc',
    '96': 'color: #26c6da',
    '97': 'color: #fff',
  }
  
  // Replace ANSI codes with HTML spans
  let html = text
    // Remove cursor movement codes (used by progress bars)
    .replace(/\x1b\[[0-9]*[A-G]/g, '')
    // Remove clear line codes
    .replace(/\x1b\[2K/g, '')
    // Replace color codes
    .replace(/\x1b\[([0-9;]+)m/g, (match, codes) => {
      const codeList = codes.split(';')
      const styles: string[] = []
      
      for (const code of codeList) {
        if (code === '0') {
          // Reset
          return '</span>'
        } else if (code === '1') {
          // Bold
          styles.push('font-weight: bold')
        } else if (colorMap[code]) {
          styles.push(colorMap[code])
        }
      }
      
      if (styles.length > 0) {
        return `<span style="${styles.join('; ')}">`
      }
      return ''
    })
  
  // Ensure all spans are closed
  const openSpans = (html.match(/<span/g) || []).length
  const closeSpans = (html.match(/<\/span>/g) || []).length
  for (let i = 0; i < openSpans - closeSpans; i++) {
    html += '</span>'
  }
  
  return html
}